import { Box, styled } from '@material-ui/core';
import { SText } from '@setvi/shared/components';
import { TextColor } from '@setvi/shared/enums';

export const ProductValueWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  color: TextColor.SlateGrey
});

interface ProductValueProps {
  title: string;
  value: string;
  color?: TextColor;
  bullet?: boolean;
}
export const ProductValue = ({
  title,
  value = '-',
  bullet = false,
  color = TextColor.SlateGrey
}: ProductValueProps) => (
  <ProductValueWrapper>
    {bullet && (
      <span
        style={{
          lineHeight: '24px',
          fontSize: 18,
          margin: '0 6px',
          transform: 'translateY(-1px)'
        }}>
        •
      </span>
    )}
    <SText
      lineHeight="24px"
      title={title}
      weight="bold"
      maxLines={1}
      fontColor={color}
      style={{ marginRight: 4 }}
    />
    <SText lineHeight="24px" title={value} fontColor={color} />
  </ProductValueWrapper>
);
